var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveriesIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1602 2.3835H15.1425V10.5L12 7.446L8.85672 10.5V2.3835H4.83972C3.28122 2.3835 2.01672 3.648 2.01672 5.2065V18.7942C2.01672 20.3527 3.28122 21.6172 4.83972 21.6172H19.1602C20.7187 21.6172 21.9832 20.3527 21.9832 18.7942V5.20575C21.9832 3.64725 20.7187 2.3835 19.1602 2.3835ZM10.5015 18.429H5.15772V16.038H10.5015V18.429Z",
    fill: "#082645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveriesIconBlack);
export default __webpack_public_path__ + "static/media/deliveriesIconBlack.fea7571d39cfc88d763c5d370afaec76.svg";
export { ForwardRef as ReactComponent };